import z from "zod";
import { absenceCategories } from "../../absences";

export const substitutionPlanDetailSchema = z.object({
	id: z.string(),
	absenceId: z.string(),
	userId: z.string(),
	startDate: z.string(),
	endDate: z.string(),
	state: z.enum(["active", "inactive", "pending"]),
	category: z.enum(absenceCategories),
	firstName: z.string().nullish(),
	lastName: z.string().nullish(),
});

export type SubstitutionPlanDetailSchema = z.infer<typeof substitutionPlanDetailSchema>;
